module.exports = __webpack_public_path__ + "static/media/AQ-FONDO.5da7e99b.png";